import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-down-black.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("h2", { class: "text-base font-semibold text-gray-lp-300" }, "Detail barang", -1)
const _hoisted_2 = { class: "space-y-1 px-2" }
const _hoisted_3 = { class: "flex flex-col gap-1 pb-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row gap-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-medium text-sm text-gray-lp-600 w-1/2" }, "Berat kotor"),
  /*#__PURE__*/_createVNode("div", { class: "font-medium text-sm text-gray-lp-600 w-1/2" }, "Dimensi")
], -1)
const _hoisted_5 = { class: "flex flex-row gap-3" }
const _hoisted_6 = { class: "font-semibold text-base text-gray-lp-300 w-1/2" }
const _hoisted_7 = { class: "font-semibold text-base text-gray-lp-300 w-1/2" }
const _hoisted_8 = { class: "flex flex-col gap-1 pb-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row gap-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-medium text-sm text-gray-lp-600 w-1/2" }, "Berat dikenakan biaya"),
  /*#__PURE__*/_createVNode("div", { class: "font-medium text-sm text-gray-lp-600 w-1/2" }, "Koli")
], -1)
const _hoisted_10 = { class: "flex flex-row gap-3" }
const _hoisted_11 = { class: "font-semibold text-base text-gray-lp-300 w-1/2" }
const _hoisted_12 = { class: "font-semibold text-base text-gray-lp-300 w-1/2" }
const _hoisted_13 = { class: "flex flex-col gap-1 pb-2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row gap-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-medium text-sm text-gray-lp-600 w-1/2" }, "Tagihan COD"),
  /*#__PURE__*/_createVNode("div", { class: "font-medium text-sm text-gray-lp-600 w-1/2" }, "Harga barang")
], -1)
const _hoisted_15 = { class: "flex flex-row gap-3" }
const _hoisted_16 = { class: "font-semibold text-base text-gray-lp-300 w-1/2" }
const _hoisted_17 = { class: "font-semibold text-base text-gray-lp-300 w-1/2" }
const _hoisted_18 = { class: "flex flex-col gap-1 pb-2" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "font-medium text-sm text-gray-lp-600" }, "Asuransi", -1)
const _hoisted_20 = { class: "font-semibold text-base text-gray-lp-300" }
const _hoisted_21 = { class: "flex flex-col gap-1" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "font-medium text-sm text-gray-lp-600" }, "Komoditas", -1)
const _hoisted_23 = { class: "flex flex-row gap-1" }
const _hoisted_24 = { class: "overflow-ellipsis overflow-hidden whitespace-nowrap" }
const _hoisted_25 = { class: "flex flex-col text-12px" }
const _hoisted_26 = { class: "font-bold" }
const _hoisted_27 = {
  key: 0,
  class: "flex flex-row gap-1 justify-end items-center"
}
const _hoisted_28 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_29 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", {
    class: 
      `${
        _ctx.isCollapsed ? '' : 'pb-2'
      } pt-2 bg-white rounded-lg border border-gray-lp-1400 mt-2`
    
  }, [
    _createVNode("div", {
      class: 
        `${
          _ctx.isCollapsed ? '' : 'mb-2'
        } pb-2 flex items-center justify-between border-b px-2`
      
    }, [
      _hoisted_1,
      _createVNode("button", {
        class: "p-2 hover:bg-gray-100 rounded-full",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse && _ctx.toggleCollapse(...args)))
      }, [
        _createVNode("img", {
          src: _imports_0,
          class: ["w-6 h-6 transition-transform duration-200", { 'transform rotate-180': !_ctx.isCollapsed }],
          alt: "chevron"
        }, null, 2)
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.formatWeightNumber(_ctx.summary.grossWeight)) + " kg", 1),
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.summary.dimLength) + " x " + _toDisplayString(_ctx.summary.dimWidth) + " x " + _toDisplayString(_ctx.summary.dimHeight) + " cm", 1)
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.formatWeightNumber(_ctx.summary.chargeableWeight)) + " kg", 1),
          _createVNode("div", _hoisted_12, _toDisplayString(_ctx.summary.totalPiece), 1)
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.formatPriceNumber(_ctx.summary.codAmount)), 1),
          _createVNode("div", _hoisted_17, _toDisplayString(_ctx.formatPriceNumber(_ctx.summary.goodsPrice)), 1)
        ])
      ]),
      _createVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode("div", _hoisted_20, _toDisplayString(_ctx.summary.isInsurance ? "Ya" : "Tidak"), 1)
      ]),
      _createVNode("div", _hoisted_21, [
        _hoisted_22,
        _createVNode("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            _createVNode("div", {
              class: "font-semibold text-base overflow-ellipsis overflow-hidden whitespace-nowrap text-gray-lp-300 cursor-default",
              onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTooltip($event))),
              onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTooltip($event)))
            }, _toDisplayString(_ctx.summary.commodityName), 33),
            _createVNode(_component_OverlayPanel, {
              ref: "commodityName",
              appendTo: "body",
              style: {
                backgroundColor: '#4D4D4D',
                color: '#ffffff'
              }
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, _toDisplayString(_ctx.summary.commodityName), 1)
                ])
              ]),
              _: 1
            }, 512)
          ]),
          (_ctx.summary.commodityIsQuarantine || _ctx.summary.commodityIsDg)
            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                (_ctx.summary.commodityIsQuarantine)
                  ? (_openBlock(), _createBlock("span", _hoisted_28, " K "))
                  : _createCommentVNode("", true),
                (_ctx.summary.commodityIsDg)
                  ? (_openBlock(), _createBlock("span", _hoisted_29, " DG "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.isCollapsed]
    ])
  ], 2))
}